"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MMOPluginObjectType = void 0;
var MMOPluginObjectType;
(function (MMOPluginObjectType) {
    MMOPluginObjectType["Spawner"] = "spawner";
    MMOPluginObjectType["PlayerSpawn"] = "playerSpawn";
})(MMOPluginObjectType || (exports.MMOPluginObjectType = MMOPluginObjectType = {}));
